var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delete"},[_c('b-modal',{ref:"modallg",attrs:{"id":"modallg","size":"lg","title":_vm.title,"header-bg-variant":"success","body-text-variant":"dark"},on:{"ok":_vm.deletedata}},[_vm._v(" "+_vm._s(_vm.$t("删除确认"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }